<template>
  <div class="standardsExtension">
    <el-tabs v-model="activeName">
      <el-tab-pane label="1DING模型" name="name0">开发中敬请期待...</el-tab-pane>
      <el-tab-pane label="关联标准" name="name1">
        <div style="font-weight:900">与本标准同属一个系列和/或相关的标准包括：</div>
        <div class="serials">
          <serials />
        </div>
      </el-tab-pane>
      <el-tab-pane label="中英文对照" name="name2">
        <div class="contents hidenScrollbar">
          <div v-if="relatedStandardsContents == null">
            <p>本标准无对应的中/英文标准或对应的中英文标准尚未整理完成。</p>
            <p>对于已经发布中文版（GB）的的国际标准（ISO），小编正在加紧整理中，敬请随时回来查看。</p>
          </div>
          <div v-else style="margin-top:-0.2rem;height:calc(100vh - 2rem)">
            <contents :standardsContents="relatedStandardsContents" />
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="分析问卷" name="name3">开发中敬请期待...</el-tab-pane>
      <el-tab-pane label="管理制度" name="name4">开发中敬请期待...</el-tab-pane>
      <el-tab-pane label="技术措施" name="name5">开发中敬请期待...</el-tab-pane>
      <el-tab-pane label="培训视频" name="name6">开发中敬请期待...</el-tab-pane>
      <el-tab-pane label="其他参考" name="name7">开发中敬请期待...</el-tab-pane>
      <el-tab-pane label="自由讨论" name="name8">开发中敬请期待...</el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import Bus from "@/misc/bus.js";
  import contents from "@/components/standards/show/contents.vue";
  import serials from "@/components/standards/serials/serials.vue";
  export default {
    name: "extension",
    data() {
      return {
        activeName: "name1"
      };
    },
    props: {
      standardsExt: Object
    },
    computed: {
      relatedStandardsContents() {
        return this.$store.state.standards.relatedStandardsContents;
      }
    },
    components: {
      contents,
      serials
    },
    created() {
      //获取对应的中英文标准
      if (this.standardsExt.related_standards_code != null) {
        this.$store.dispatch(
          "standards/getRelatedStandardsContents",
          this.standardsExt.related_standards_code
        );
      }
      //获取相关的标准清单
      if (this.standardsExt.serials != null) {
        this.$store.dispatch("standards/getSerials", this.standardsExt.serials);
      }
    },
    mounted() {
      //点击左边的目录， 右边的中英文同时滚动
      //定义查找第二个字符串的位置
      function find(str, cha) {
        var x = str.indexOf(cha);
        x = str.indexOf(cha, x + 1);
        return x;
      }
      // 形成中英文标准根据目录结构的关联滚动
      Bus.$on("code", e => {
        this.$nextTick(() => {
          if (
            this.relatedStandardsContents &&
            this.relatedStandardsContents.length > 0
          ) {
            document
              .getElementById(
                this.relatedStandardsContents[0].clause_code +
                e.slice(find(e, "-"), e.length)
              )
              .scrollIntoView();
          }
        });
      });
    }
  };
</script>

<style scoped>
  .standardsExtension {
    margin-top: 0.2rem;
    height: calc(100vh - 1.4rem);
  }
</style>

<style>
  .standardsExtension .el-tabs__nav-wrap::after {
    height: 1px;
    background-color: gray !important
  }

  .standardsExtension .el-tabs__item {
    font-size: 0.12rem !important;
    color: black !important;
  }

  .standardsExtension .el-tabs__item.is-active {
    color: white !important;
    background-color: #aa0000 !important;
    border-bottom: 1px solid gray !important;
    padding: 0 0.1rem !important;
  }

  .standardsExtension .el-tabs__item:hover {
    color: white !important;
    background-color: gray !important;
  }
</style>